import { Button } from '@/components/ui'
import { ClientType } from '@/data/portfolio'

interface PortfolioCTAProps {
  clientTypes?: ClientType[]
}

interface CTAContent {
  heading: string
  subheading: string
  buttonText: string
}

function getCTAContent(clientTypes?: ClientType[]): CTAContent {
  if (!clientTypes || clientTypes.length === 0) {
    return {
      heading: 'Inspired by this project?',
      subheading: "Let's talk about how Fugue Lab can bring your vision to life.",
      buttonText: 'Start Your Project',
    }
  }

  // Check for specific client types and return relevant CTA
  if (clientTypes.includes(ClientType.School) || clientTypes.includes(ClientType.University)) {
    return {
      heading: 'Need a platform for your school?',
      subheading: 'We build custom digital solutions for educational institutions.',
      buttonText: 'Discuss Your Project',
    }
  }

  if (clientTypes.includes(ClientType.Festival)) {
    return {
      heading: 'Planning a festival?',
      subheading: 'From applications to websites, we help festivals succeed online.',
      buttonText: 'Get a Festival Quote',
    }
  }

  if (clientTypes.includes(ClientType.Church)) {
    return {
      heading: 'Serving a church or parish?',
      subheading: 'We specialize in music ministry and liturgical websites.',
      buttonText: 'Start a Conversation',
    }
  }

  if (clientTypes.includes(ClientType.Ensemble) || clientTypes.includes(ClientType.Quartet)) {
    return {
      heading: 'Have an ensemble?',
      subheading: 'We create stunning websites that showcase your artistry.',
      buttonText: 'Get Started',
    }
  }

  if (
    clientTypes.includes(ClientType.Soloist) ||
    clientTypes.includes(ClientType.Vocalist) ||
    clientTypes.includes(ClientType.Organist)
  ) {
    return {
      heading: 'Ready for a professional website?',
      subheading: 'Stand out with a site that reflects your artistry.',
      buttonText: 'Build Your Site',
    }
  }

  if (clientTypes.includes(ClientType.Publication)) {
    return {
      heading: 'Starting a publication?',
      subheading: 'We build content platforms designed for growth.',
      buttonText: 'Learn More',
    }
  }

  // Default fallback
  return {
    heading: 'Inspired by this project?',
    subheading: "Let's talk about how Fugue Lab can bring your vision to life.",
    buttonText: 'Start Your Project',
  }
}

export function PortfolioCTA({ clientTypes }: PortfolioCTAProps) {
  const { heading, subheading, buttonText } = getCTAContent(clientTypes)

  return (
    <div className="mt-12 border-t pt-10 text-center">
      <h2 className="mb-4 text-2xl font-semibold">{heading}</h2>
      <p className="text-muted-foreground mb-6">{subheading}</p>
      <Button asChild size="lg">
        <a href="/book" target="_blank" rel="noopener noreferrer">
          {buttonText}
        </a>
      </Button>
    </div>
  )
}
